import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Highcharts from 'highcharts';
import { ScatterchartService } from '../../scatterchart.service';
import HC_accessibility from 'highcharts/modules/accessibility';
import { name } from '@azure/msal-angular/packageMetadata';
// import { url } from 'inspector';
import HC_3D from 'highcharts/highcharts-3d';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-scatterchart02',
  templateUrl: './scatterchart02.component.html',
  styleUrls: [],
})
export class Scatterchart02ComponentCustom implements OnInit {
  constructor(private http: HttpClient, private ss: ScatterchartService, private _customSnapshotService: CustomsnapshotService, private _configService: SnapshotService,private route: ActivatedRoute) { }

  chart: any;
  data: any;
  color: any;
  chartproperties: any;
  seriesdata: any;
  imageseriesdata: any;
  image1: any;
  jsondata: any;
  sampleSizeConstandValue = 12000;
  title: any;
  quadrantText: any;
  // @Input() height="25em";

  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any;

  private subscriptions: Subscription = new Subscription();
  significanceValue: any = "None";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
  configuredProperties: any;
  chartMainData: any;
  xAxisTitle: any = "";
  yAxisTitle: any = "";
  percentageForX : boolean = false;
  percentageForY : boolean = false;
  userselectedchartdata: any;

  ngOnInit(): void {
    if (this.isOutput) {
      if (this.sort == 0) {
        this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
      }
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric;

      this.color = this.ss.color;
      //this.image1 = this.data.map((brandData: any) => brandData.image);
      //this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));

      // this.maxDataPoints = this.layoutNumber == 2 ? 12 : this.popUp ? 10 : this.maxDataPoints;
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));

    }
    else {
      this.http
        .get<any>('assets/Data/scatterData.json')
        .subscribe((data: any) => {
          this.quadrantText = data[0]['quadrantText'][0];
          
          const dataJson = data[0];
          this.jsondata = dataJson;
          this.data = dataJson['data'];
          this.chartproperties = dataJson['properties'][0];
          this.chartproperties.showLegend = true;
          this.title = dataJson['title'];
          this.color = this.ss.color;
          this.image1 = this.data.map((brandData: any) => brandData.image);

        
          this.route.paramMap.subscribe((params) => {
            const userData = history.state.userData;
            this.userselectedchartdata = userData; // Use the userData object as needed
            if (this.userselectedchartdata?.widgetEditSelection) {
              if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
                this.chartproperties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
              }
            }
          });
          HC_3D(Highcharts);
          this.generatechart(
            'chart-container' + this.id,
            this.data,
            this.chartproperties,
            this.seriesdata
          );
        });
    }
  }

  chartData(data: any, markerSymbol: any) {
    if (this.isOutput) {
      this.seriesdata = data.map((i: any, index: any) => {
        return {
          name: i.brand,
          marker: {
            symbol:
              markerSymbol != 'image'
                ? markerSymbol
                : `url(${this.ss.baseImgPath + i.image + '.png'})`,
            radius: 5,
            width: 10,
            height: 10,
          },
          color: this.color[index],
          data: i.data.map((point: any) => ({
            x:
              this.chartproperties.datalabelStyle === 'ls' &&
                point['Sample size'] < this.sampleSizeConstandValue
                ? 0
                : point.x,
            y:
              this.chartproperties.datalabelStyle === 'ls' &&
                point['Sample size'] < this.sampleSizeConstandValue
                ? 0
                : Number(parseFloat(point.y).toFixed(this.chartproperties.decimalRoundOff)),
            metric: point.metric,
            significance: point.Significance,
            significance2: point.Significance2,
            covx: point['ChangeVsx'],
            covy: point['ChangeVsy'],
            samplesizex: point['Sample sizex'],
            samplesizey: point['Sample sizey'],
            indexValuex: (this._configService.userRole != "superadmin" && Number(point['Sample sizex']) <= this._configService.ISthreshold ? 0 : (point['ValueForIndexx'] == null ? 0 : point['ValueForIndexx'])),
            actualIndexValuex: point['ActualIndexValuex'],
            indexValuey: (this._configService.userRole != "superadmin" && Number(point['Sample sizey']) <= this._configService.ISthreshold ? 0 : (point['ValueForIndexy'] == null ? 0 : point['ValueForIndexy'])),
            actualIndexValuey: point['ActualIndexValuey'],
            tooltip: "",
            isPercentageX: point["isPercentageX"],
            isPercentageY: point["isPercentageY"],
            Sig_LowerLimt: this.Sig_LowerLimt,
            Sig_UpperLimt: this.Sig_UpperLimt,
            Significance_Valuex: point["Significance_Valuex"],
            Significance_Valuey: point["Significance_Valuey"]
          })) as { x: number; y: number; metric: string }[],
        };
      });
    }
    else {
      const snapshottype_name= sessionStorage.getItem('issnapshottype');

      this.seriesdata = data.map((i: any, index: any) => {
        let updatedBrand:string;

            if(snapshottype_name=='Multiple Markets'){
              updatedBrand=`Market ${index + 1}`

            }else if(snapshottype_name=='Multiple Categories'){
              updatedBrand= `Category ${index + 1}`;
            }else{
              updatedBrand=i.brand;
            }
        return {
          name: updatedBrand,
          marker: {
            symbol:
              markerSymbol != 'image'
                ? markerSymbol
                : `url(${this.ss.baseImgPath + i.image + '.png'})`,
            radius: 5,
            width: 10,
            height: 10,
          },
          color: this.color[index],
          data: i.data.map((point: any) => ({
            x:
              this.chartproperties.datalabelStyle === 'ls' &&
                point['Sample size'] < this.sampleSizeConstandValue
                ? 0
                : point.x,
            y:
              this.chartproperties.datalabelStyle === 'ls' &&
                point['Sample size'] < this.sampleSizeConstandValue
                ? 0
                : Number(parseFloat(point.y).toFixed(this.chartproperties.decimalRoundOff)),
            metric: updatedBrand,
            significance: point.Significance,
            significance2: point.Significance2,
            cv: point['ChangeVs'],
            samplesize: point['Sample size'],
          })) as { x: number; y: number; metric: string }[],
        };
      });
    }
  }

  generatechart(container: any, data: any, properties: any, seriesData: any) {
    if (this.isOutput) {
      let height = this.height;
      localStorage.setItem('properties', JSON.stringify(properties));
      HC_accessibility(Highcharts);
      this.chartData(data, properties.markerStyle);

      let maxX = Math.max(
        ...this.seriesdata.flatMap((series: any) =>
          series.data.map((point: any) => point.x)
        )
      );
      let maxY = Math.max(
        ...this.seriesdata.flatMap((series: any) =>
          series.data.map((point: any) => point.y)
        )
      );
      let xAxisTitle = this.xAxisTitle;
      let yAxisTitle = this.yAxisTitle;
      let yAxisPlotLine = maxY / 2;
      let xAxisPlotLine = maxX / 2;
      let configService = this._configService;
      this.chart = Highcharts.chart(container, {
        accessibility: {},
        chart: {
          type: 'scatter',
          animation: false,
          backgroundColor: this.chartproperties.darkTheme ? '#333' : 'white',
          style: {
            fontFamily: this.ss.fontFamily,
            fontSize: "0.7rem"
          },
          renderTo: 'chart-container' + this.id,
          zoomType: 'xy',
          options3d: {
            enabled: properties.is3D,
            alpha: -1,
            beta: -1,
            depth: 190,
            viewDistance: 4,
            fitToPlot: false,
            dataLabels: {
              enabled: true,
              allowOverlap: true,
            },
          },
        },
        title: {
          text: "",
          align: properties.chartTitlePosition,
          verticleAlign: 'top',
          style: {
            color: properties.darkTheme ? 'white' : 'black',
          },
        },
        legend: {
          enabled: properties.showLegend,
          layout:
            properties.legendPosition !== 'bottom' ? 'vertical' : 'horizontal',
          verticalAlign:
            properties.legendPosition !== 'bottom' ? 'middle' : 'bottom',
          align:
            properties.legendPosition === 'bottom'
              ? 'center'
              : properties.legendPosition,
          itemStyle: {
            color: properties.darkTheme ? 'white' : 'black',
            fontWeight: 'normal',
            fontSize: '0.8em',
          },
          useHTML:  properties.legendPosition !== 'bottom'?true:false,
          symbolWidth: properties.legendPosition !== 'bottom'? 0:8,
          symbolHeight: properties.legendPosition !== 'bottom'?0:8,
          labelFormatter: function (): any {
            let point = this as any;
            let textcolor = properties.darkTheme ? 'white' : 'black';
            if (point.color != "#eeebed" && point.color != "#7f7f7f") {
              return '<div style="display:flex;align-items:center;font-size:0.7em;" title="' + point.name + '">'
                + '<div style="display:flex;width:10px;height:10px;background-color:' + point.color + ';border-radius:50%"></div>'
                + '<div style="width:' + (height != "100%" ? '120px' : '19.5rem') + ';height:20px;font-size:0.6rem;padding-left:10px;padding-top:5px;color:' + textcolor + ';overflow:hidden;white-space:nowrap;text-overflow:ellipsis;flex:1;" title="' + point.name + '">' + '   ' + point.name + '   ' + '</div>'
                + '</div>';
            }
          },
        },
        plotOptions: {
          series: {
            animation: false,
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            },
          },
          scatter: {
            dataLabels: {
              enabled: properties.showDataLabel,
              allowOverlap: true,
              style: {
                fontSize: properties.dataLabelSize,
                color:
                  properties.dataLabelColor == 'Default'
                    ? properties.darkTheme
                      ? 'white'
                      : 'black'
                    : properties.dataLabelColor,
                fontWeight: 'none',
                textOutline: 'none',
              },
              formatter: function (
                this: Highcharts.TooltipFormatterContextObject
              ) {
                const pointWithMetric = this.point as {
                  x: number;
                  y: number;
                  metric?: string;
                  covx?: string;
                  covy?: string;
                  significance?: string;
                  significance2?: string;
                  samplesizex?: number;
                  samplesizey?: number;
                  tooltip?: any;
                  isPercentageX?: any;
                  isPercentageY?: any;
                  Sig_LowerLimt?: any;
                  Sig_UpperLimt?: any;
                  Significance_Valuex?: any;
                  Significance_Valuey?: any;
                  indexValuex?: any;
                  actualIndexValuex?: any;
                  indexValuey?: any;
                  actualIndexValuey?: any;
                };

                if (pointWithMetric.metric) {
                  let tooltipContent = '';

                  // if (properties.datalabelFormat === 'number') {
                  //   if (properties.datalabelStyle === 'change') {
                  //     return `<span style="color:${properties.dataLabelColor};">${pointWithMetric.x
                  //       } , ${pointWithMetric.y
                  //       } <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                  //       };">(${pointWithMetric.cv})</span></span>`;
                  //   } else if (properties.datalabelStyle === 'significance') {
                  //     tooltipContent = `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                  //   } else if (
                  //     properties.datalabelStyle === 'significance + changeVs'
                  //   ) {
                  //     tooltipContent = `<span style="color:${properties.dataLabelColor
                  //       };">${pointWithMetric.x} , ${pointWithMetric.y
                  //       } <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                  //       };">(${pointWithMetric.cv})</span></span>`;
                  //   } else if (properties.datalabelStyle == 'significance2') {
                  //     let color =
                  //       pointWithMetric.significance2 === '1'
                  //         ? 'green'
                  //         : pointWithMetric.significance2 === '-1'
                  //           ? 'red'
                  //           : properties.darkTheme
                  //             ? 'white'
                  //             : 'black';

                  //     const significance2Content = `<span style="color: ${color};"> ${pointWithMetric.cv} </span>`;
                  //     tooltipContent = `<span style="color:${properties.dataLabelColor
                  //       };">${pointWithMetric.x} , ${pointWithMetric.y
                  //       } <span  style="font-size: 80%;color: ${properties.darkTheme ? 'white' : 'black'
                  //       };">(${significance2Content})</span>  </span>`;
                  //   } else if (properties.datalabelStyle === 'ls') {
                  //     const metricValue: string = pointWithMetric.metric;

                  //     if (
                  //       pointWithMetric.samplesize &&
                  //       pointWithMetric.samplesize < 12000
                  //     ) {
                  //       return 'LS';
                  //     }

                  //     return `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                  //   } else {
                  //     const metricValue: string = pointWithMetric.metric;
                  //     return `<span>${metricValue}<br>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                  //   }
                  // }

                  // if (properties.datalabelFormat === 'percentage') {
                  //   if (properties.datalabelStyle === 'change') {
                  //     return `<span style="color:${properties.dataLabelColor};">${pointWithMetric.x
                  //       }% , ${pointWithMetric.y
                  //       }% <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                  //       };">(${pointWithMetric.cv})</span></span>`;
                  //   } else if (properties.datalabelStyle === 'significance') {
                  //     tooltipContent = `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                  //   } else if (properties.datalabelStyle == 'significance2') {
                  //     let color =
                  //       pointWithMetric.significance2 === '1'
                  //         ? 'green'
                  //         : pointWithMetric.significance2 === '-1'
                  //           ? 'red'
                  //           : properties.darkTheme
                  //             ? 'white'
                  //             : 'black';
                  //     const significance2Content = `<span style="color: ${color};"> ${pointWithMetric.cv} </span>`;
                  //     tooltipContent = `<span style="color:${properties.dataLabelColor
                  //       };">${pointWithMetric.x}% , ${pointWithMetric.y
                  //       }% <span  style="font-size: 80%;color: ${properties.darkTheme ? 'white' : 'black'
                  //       };">(${significance2Content})</span>  </span>`;
                  //   } else if (
                  //     properties.datalabelStyle === 'changeversus+significance'
                  //   ) {
                  //     tooltipContent = `<span style="color:${properties.dataLabelColor
                  //       };">${pointWithMetric.x}% , ${pointWithMetric.y
                  //       }% <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                  //       };">(${pointWithMetric.cv})</span></span>`;
                  //   } else if (properties.datalabelStyle === 'ls') {
                  //     if (
                  //       pointWithMetric.samplesize &&
                  //       pointWithMetric.samplesize < 12000
                  //     ) {
                  //       return 'LS';
                  //     }

                  //     return `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                  //   } else {
                  //     const metricValue: string = pointWithMetric.metric;
                  //     return `<span>${metricValue}<br>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                  //   }
                  // }

                  // if (pointWithMetric.significance === '1') {
                  //   tooltipContent +=
                  //     '<span style="color: green;"> &#9650;</span>';
                  // } else if (pointWithMetric.significance === '-1') {
                  //   tooltipContent += '<span style="color: red;"> &#9660;</span>';
                  // } else {
                  //   tooltipContent += '';
                  // }

                  return tooltipContent;
                } else {
                  let textcolor = properties.dataLabelColor;
                  if (properties.datalabelStyle == "default") {
                    // return `<span>${this.series.name}</span><br>X: ${pointWithMetric.x}, Y: ${pointWithMetric.y}`;
                    pointWithMetric.tooltip = `<span>${xAxisTitle} : ${pointWithMetric.x+(pointWithMetric.isPercentageX ? '%' : '')}</span><br><span>${yAxisTitle} : ${pointWithMetric.y+(pointWithMetric.isPercentageY ? '%' : '')}</span>`;
                    return `<span>(${pointWithMetric.x+(pointWithMetric.isPercentageX ? '%' : '')}, ${pointWithMetric.y+(pointWithMetric.isPercentageY ? '%' : '')})</span>`;
                  }
                  if (properties.datalabelStyle == "sigChange") {
                    let textCheckx = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.x), Number(pointWithMetric.samplesizex));
                    let textChecky = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesizey));
                    let changeValx = pointWithMetric.isPercentageX ? (Number(pointWithMetric.covx) * 100) : (Number(pointWithMetric.covx));
                    let changeValy = pointWithMetric.isPercentageY ? (Number(pointWithMetric.covy) * 100) : (Number(pointWithMetric.covy));
                    if ((pointWithMetric.covx == null || pointWithMetric.covx == 'NA') && (pointWithMetric.covy == null || pointWithMetric.covy == 'NA')) {
                      let textx = textCheckx + (pointWithMetric.isPercentageX ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                      let texty = textChecky + (pointWithMetric.isPercentageY ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                      let finalText = '<span style="color:' + textcolor + ';">(' + textx + '</span>, ' + '<span style="color:' + textcolor + ';">' + texty + ')</span>'
                      pointWithMetric.tooltip = `<div><span>${xAxisTitle} : <span style="color:${textcolor};">${textx}</span></span><br>
                      <span>${yAxisTitle} : <span style="color:${textcolor};">${texty}</span></span></div> `;
                      return finalText;
                    }
                    else {
                      let sigClassx = pointWithMetric.Significance_Valuex < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Valuex > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                      let sigClassy = pointWithMetric.Significance_Valuey < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Valuey > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                      //let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + (textCheck !='I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) : 'NA'})</span>` : 'NA') : '');
                      let textx = textCheckx + ((properties.isPercentageX && textCheckx != 'I/S') ? '%' : '') + ' ' + (textCheckx != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClassx};">(` + `${(pointWithMetric.covx != null ? parseFloat(Number(changeValx).toFixed(1)) + (pointWithMetric.isPercentageX ? '%' : '') : 'NA')})</span>`) : '');
                      let texty = textChecky + ((properties.isPercentageY && textChecky != 'I/S') ? '%' : '') + ' ' + (textChecky != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClassy};">(` + `${(pointWithMetric.covy != null ? parseFloat(Number(changeValy).toFixed(1)) + (pointWithMetric.isPercentageY ? '%' : '') : 'NA')})</span>`) : '');
                      let finalText = '<span style="color:' + textcolor + ';">(' + textx + '</span>, ' + '<span style="color:' + textcolor + ';">' + texty + ')</span>'
                      pointWithMetric.tooltip = `<div><span>${xAxisTitle} : <span style="color:${textcolor};">${textx}</span></span><br>
                                                 <span>${yAxisTitle} : <span style="color:${textcolor};">${texty}</span></span></div> `;
                      return (
                        finalText
                      );

                    }

                  }
                  if (properties.datalabelStyle == "index") {
                    let textx = pointWithMetric.x != null ? pointWithMetric.x + (pointWithMetric.isPercentageX ? '%' : '') : 'NA';
                    textx = configService.CheckLSorIScondition(configService.userRole, textx, Number(pointWithMetric.samplesizex));
                    let texty = pointWithMetric.y != null ? pointWithMetric.y + (pointWithMetric.isPercentageY ? '%' : '') : 'NA';
                    texty = configService.CheckLSorIScondition(configService.userRole, texty, Number(pointWithMetric.samplesizey));
                    // let text2 = pointWithMetric.y1 == 0 ? 'NA' :pointWithMetric.y1 == -1 ? -1 : pointWithMetric.y1 != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';
                    let text2x = pointWithMetric.actualIndexValuex == null ? 'NA' : pointWithMetric.x == -1 ? -1 : pointWithMetric.x != null ? pointWithMetric.indexValuex.toFixed(1) : 'NA';
                    let text2y = pointWithMetric.actualIndexValuey == null ? 'NA' : pointWithMetric.y == -1 ? -1 : pointWithMetric.y != null ? pointWithMetric.indexValuey.toFixed(1) : 'NA';

                    if ((text2x == "-1" || text2x == -1) && (text2y == "-1" || text2y == -1)) {
                      text2x = "NA"; text2y = "NA";
                    }
                    text2x = configService.CheckLSorIScondition(configService.userRole, String(text2x), Number(pointWithMetric.samplesizex));
                    text2y = configService.CheckLSorIScondition(configService.userRole, String(text2y), Number(pointWithMetric.samplesizey));
                    let colorx = configService.CheckIndexColoring(String(text2x));
                    let colory = configService.CheckIndexColoring(String(text2y));
                    let finalText = '<span style="font-size:0.5rem;color:' + textcolor + ';">(' + textx + " " + '(' +
                      '<span style="color:' + colorx + ';font-size:0.45rem;">' + text2x + '</span>' + ')</span>, ' +
                      '<span style="font-size:0.5rem;color:' + textcolor + ';">' + texty + " " + '(' +
                      '<span style="color:' + colory + ';font-size:0.45rem;">' + text2y + '</span>' + '))</span>'
                    pointWithMetric.tooltip = '<span style="font-size:0.5rem;color:' + textcolor + ';">' +xAxisTitle+' : '+textx + " " + '(' +
                      '<span style="color:' + colorx + ';font-size:0.45rem;">' + text2x + '</span>' + ')</span><br>' +
                      '<span style="font-size:0.5rem;color:' + textcolor + ';">'+yAxisTitle+' : '+ texty + " " + '(' +
                      '<span style="color:' + colory + ';font-size:0.45rem;">' + text2y + '</span>' + ')</span>';
                    return finalText;
                  }
                  return null;
                }
              },
            },

            marker: {
              radius: 5,
              width: 10,
              height: 10,
              states: {
                hover: {
                  enabled: true,
                  lineColor: 'rgb(100,100,100)',
                },
              },
            },
            states: {
              hover: {
                enabled: false,
              },
            },
          },
        },
        xAxis: {
          max: maxX + 2,
          title: {
            text: this.xAxisTitle,
            useHTML: true, // Enable HTML formatting if needed
            formatter: function (this : any):any {
              // Custom formatter logic
              let xAxisTitle=this.xAxisTitle
              if(!this.popUp){
                 xAxisTitle= this.xAxisTitle.slice(0, 50) + '...' 
              }
              return `<span style="color: blue; font-weight: bold;title:${this.xAxisTitle}">${xAxisTitle}</span>`;
            },
            style: {
              color: properties.darkTheme ? 'white' : 'black',
            },
          },

          labels: {
            rotation: this.chartproperties.axisLabelOrientation === 'vertical' ? -90 : (this.chartproperties.axisLabelOrientation === 'angled' ? -45 : 0),
            format:
              properties.datalabelFormat == 'percentage' ? '{value}%' : '{value}',
            style: {
              color: properties.darkTheme ? 'white' : 'black',
            },
          },
          startOnTick: true,
          endOnTick: false,
          showLastLabel: true,
          gridLineWidth: properties.gridlines === true ? 1 : 0,
          plotLines: [
            {
              color: properties.dashStyle != 'none'
                ? properties.showQuadrantcolor
                : 'transparent',
              dashStyle: properties.dashStyle,
              value: maxX / 2,
              width: 2,
              label: {
                align: 'right',
              },
            },
          ],
          // plotBands: [
          //   {
          //     color:
          //       properties.showQuadrantcolor === 'enable' &&
          //         properties.showGradient === 'enable'
          //         ? {
          //           linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
          //           stops: [
          //             [0, 'rgba(0, 0, 255, 0.2)'],
          //             [1, 'rgba(0, 0, 255, 0.4)'],
          //           ],
          //         }
          //         : properties.showQuadrantcolor === 'enable'
          //           ? 'rgba(0, 0, 255, 0.2)'
          //           : 'transparent',

          //     from: 0,
          //     to: xAxisPlotLine,
          //     label: {
          //       text:
          //         properties.showQuadrantText === 'enable'
          //           ? this.quadrantText.quadrantText1
          //           : '',
          //       style: {
          //         color: properties.darkTheme ? 'white' : 'black',
          //       },
          //       align: 'left',
          //       x: 10,
          //       y: 15,
          //     },
          //   },
          //   {
          //     color:
          //       properties.showQuadrantcolor === 'enable' &&
          //         properties.showGradient === 'enable'
          //         ? {
          //           linearGradient: { x1: 1, x2: 0, y1: 0, y2: 0 },
          //           stops: [
          //             [0, 'rgba(0, 255, 0, 0.2)'],
          //             [1, 'rgba(0, 255, 0, 0.1)'],
          //           ],
          //         }
          //         : properties.showQuadrantcolor != 'disable'
          //           ? properties.showQuadrantcolor
          //           : 'transparent',

          //     from: -xAxisPlotLine,
          //     to: 0,
          //     label: {
          //       text:
          //         properties.showQuadrantText === 'enable'
          //           ? this.quadrantText.quadrantText2
          //           : '',
          //       style: {
          //         color: properties.darkTheme ? 'white' : 'black',
          //       },
          //       align: 'right',
          //       x:
          //         properties.legendPosition === 'right'
          //           ? properties.is3D
          //             ? 600
          //             : 620
          //           : properties.legendPosition === 'left'
          //             ? properties.is3D
          //               ? 200
          //               : 620
          //             : properties.is3D
          //               ? 400
          //               : 700,
          //       y: properties.is3D ? 30 : 15,
          //     },
          //   },
          // ],
        },
        yAxis: {
          max: maxY,
          title: {
            text: this.yAxisTitle,
            useHTML: true, // Enable HTML formatting if needed
            formatter: function (this : any):any {
              // Custom formatter logic
              let yAxisTitle=this.yAxisTitle
              if(!this.popUp){
                yAxisTitle= this.yAxisTitle.slice(0, 50) + '...' 
              }
              return `<span style="color: blue; font-weight: bold;title:${this.yAxisTitle}">${yAxisTitle}</span>`;
            },
            style: {
              color: properties.darkTheme ? 'white' : 'black',
            },
          },

          labels: {
            rotation: this.chartproperties.yaxisLabelOrientation === 'vertical' ? -90 : (this.chartproperties.yaxisLabelOrientation === 'angled' ? -45 : 0),
            format:
              properties.datalabelFormat == 'percentage' ? '{value}%' : '{value}',
            style: {
              color: properties.darkTheme ? 'white' : 'black',
            },
          },
          tickWidth: 1,
          lineWidth: 1,
          startOnTick: true,
          endOnTick: false,
          showLastLabel: true,
          gridLineWidth: properties.gridlines === true ? 1 : 0,
          plotLines: [
            {
              color: properties.dashStyle != 'none'
                ? properties.showQuadrantcolor
                : 'transparent',
              dashStyle: properties.dashStyle,
              value: maxY / 2,
              width: 2,
              label: {
                align: 'right',
              },
            },
          ],
          plotBands: [
            {
              color:
                properties.showQuadrantcolor === 'enable' &&
                  properties.showGradient === 'enable'
                  ? {
                    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                    stops: [
                      [0, 'rgba(255, 165, 0, 0.2)'],
                      [1, 'rgba(255, 165, 0, 0.7)'],
                    ],
                  }
                  : properties.showQuadrantcolor === 'enable'
                    ? 'rgba(255, 165, 0, 0.2)'
                    : 'transparent',

              from: 0,
              to: yAxisPlotLine,
              label: {
                text:
                  properties.showQuadrantText === 'enable'
                    ? this.quadrantText.quadrantText3
                    : '',
                style: {
                  color: properties.darkTheme ? 'white' : 'black',
                },
                align: 'right',
                x: -20,
                y: 50,
              },
            },
            {
              color:
                properties.showQuadrantcolor === 'enable' &&
                  properties.showGradient === 'enable'
                  ? {
                    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                    stops: [
                      [0, 'rgba(255, 0, 0, 0.1)'],
                      [1, 'rgba(255, 0, 0, 0.4)'],
                    ],
                  }
                  : properties.showQuadrantcolor === 'enable'
                    ? 'rgba(255, 0, 0, 0.2)'
                    : 'transparent',

              from: maxY,
              to: yAxisPlotLine,
              label: {
                text:
                  properties.showQuadrantText === 'enable'
                    ? this.quadrantText.quadrantText4
                    : '',
                style: {
                  color: properties.darkTheme ? 'white' : 'black',
                },
                align: 'left',
                x: 10,
                y: properties.is3D ? 155 : 180,
              },
            },
          ],
        },

        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',

          style: {
            fontSize: '0.7rem'
          },
          formatter: function (this: any): any {
            const pointWithMetric = this.point as {
              name?: any;
              parent?: any;
              color?: any;
              actualcolor?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              significance2?: string;
              samplesize?: number;
              tooltip?: any;
              Significance_Value?: any;
            };
            if (pointWithMetric.color === '#eeebed' || pointWithMetric.color === '#7f7f7f') { return false };
            const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
            if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

            let isDefaultTooltip = properties.toolTipStyle;
            if (isDefaultTooltip == "style1") {
              const dotColor = pointWithMetric.color;
              const commonContent =
                `<div style="border-left: 2px solid ` + dotColor + `;font-size:0.7rem; border-bottom: 2px solid ` + dotColor + `; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
                ` ${pointWithMetric.name} : ` +
                `${pointWithMetric.tooltip}`;
              return commonContent + '</div>';
            }
            else {
              const dotColor = pointWithMetric.color; // Get the series color

              // const content =
              //   `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor};font-size:0.7rem;max-width:10em;width:10em">` +
              //   `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0;font-size:0.7rem">${this.series.name}</div></div>` +
              //   `<div style="display: block; margin-top: 5px;;font-size:0.7rem"> ${pointWithMetric.tooltip}</div>`;

              // return content + '</div>';
              const commonContent =
              `<div style="border-left: 2px solid ` + dotColor + `;font-size:0.7em; border-bottom: 2px solid ` + dotColor + `; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
              `<span style="font-weight:bold"> ${this.series.name}</span><br>` +
              `${pointWithMetric.tooltip}`;
              return commonContent + '</div>';

            }



          },
        },
        series: this.seriesdata,
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
      } as any);
    }
    else {
      localStorage.setItem('properties', JSON.stringify(properties));
      HC_accessibility(Highcharts);
      this.chartData(data, properties.markerStyle);

      let maxX = Math.max(
        ...this.seriesdata.flatMap((series: any) =>
          series.data.map((point: any) => point.x)
        )
      );
      let maxY = Math.max(
        ...this.seriesdata.flatMap((series: any) =>
          series.data.map((point: any) => point.y)
        )
      );

      let yAxisPlotLine = maxY / 2;
      let xAxisPlotLine = maxX / 2;

      this.chart = Highcharts.chart(container, {
        accessibility: {},
        chart: {
          type: 'scatter',
          backgroundColor: this.chartproperties.darkTheme ? '#333' : 'white',
          style: {
            fontFamily: this.ss.fontFamily,
          },
          renderTo: 'chart-container' + this.id,
          zoomType: 'xy',
          options3d: {
            enabled: properties.is3D,
            alpha: -1,
            beta: -1,
            depth: 190,
            viewDistance: 4,
            fitToPlot: false,
            dataLabels: {
              enabled: true,
              allowOverlap: true,
            },
          },
        },
        title: {
          text: "",
          align: properties.chartTitlePosition,
          verticleAlign: 'top',
          style: {
            color: properties.darkTheme ? 'white' : 'black',
          },
        },
        legend: {
          enabled: properties.showLegend,
          layout:
            properties.legendPosition !== 'bottom' ? 'vertical' : 'horizontal',
          verticalAlign:
            properties.legendPosition !== 'bottom' ? 'middle' : 'bottom',
          align:
            properties.legendPosition === 'bottom'
              ? 'center'
              : properties.legendPosition,
          itemStyle: {
            color: properties.darkTheme ? 'white' : 'black',
            fontWeight: 'normal',
            fontSize: '0.8em',
          },
        },
        plotOptions: {
          series: {
            animation: false,
          },
          scatter: {
            dataLabels: {
              enabled: properties.showDataLabel,
              allowOverlap: true,
              style: {
                fontSize: properties.dataLabelSize,
                color:
                  properties.dataLabelColor == 'Default'
                    ? properties.darkTheme
                      ? 'white'
                      : 'black'
                    : properties.dataLabelColor,
                fontWeight: 'none',
                textOutline: 'none',
              },
              formatter: function (
                this: Highcharts.TooltipFormatterContextObject
              ) {
                const pointWithMetric = this.point as {
                  x: number;
                  y: number;
                  metric?: string;
                  cv?: string;
                  significance?: string;
                  significance2?: string;
                  samplesize?: number;
                };

                if (pointWithMetric.metric) {
                  let tooltipContent = '';

                  if (properties.datalabelFormat === 'number') {
                    if (properties.datalabelStyle === 'change') {
                      return `<span style="color:${properties.dataLabelColor};">${pointWithMetric.x
                        } , ${pointWithMetric.y
                        } <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                        };">(${pointWithMetric.cv})</span></span>`;
                    } else if (properties.datalabelStyle === 'significance') {
                      tooltipContent = `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                    } else if (
                      properties.datalabelStyle === 'significance + changeVs'
                    ) {
                      tooltipContent = `<span style="color:${properties.dataLabelColor
                        };">${pointWithMetric.x} , ${pointWithMetric.y
                        } <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                        };">(${pointWithMetric.cv})</span></span>`;
                    } else if (properties.datalabelStyle == 'significance2') {
                      let color =
                        pointWithMetric.significance2 === '1'
                          ? 'green'
                          : pointWithMetric.significance2 === '-1'
                            ? 'red'
                            : properties.darkTheme
                              ? 'white'
                              : 'black';

                      const significance2Content = `<span style="color: ${color};"> ${pointWithMetric.cv} </span>`;
                      tooltipContent = `<span style="color:${properties.dataLabelColor
                        };">${pointWithMetric.x} , ${pointWithMetric.y
                        } <span  style="font-size: 80%;color: ${properties.darkTheme ? 'white' : 'black'
                        };">(${significance2Content})</span>  </span>`;
                    } else if (properties.datalabelStyle === 'ls') {
                      const metricValue: string = pointWithMetric.metric;

                      if (
                        pointWithMetric.samplesize &&
                        pointWithMetric.samplesize < 12000
                      ) {
                        return 'LS';
                      }

                      return `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                    } else {
                      const metricValue: string = pointWithMetric.metric;
                      return `<span>${metricValue}<br>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                    }
                  }

                  if (properties.datalabelFormat === 'percentage') {
                    if (properties.datalabelStyle === 'change') {
                      return `<span style="color:${properties.dataLabelColor};">${pointWithMetric.x
                        }% , ${pointWithMetric.y
                        }% <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                        };">(${pointWithMetric.cv})</span></span>`;
                    } else if (properties.datalabelStyle === 'significance') {
                      tooltipContent = `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                    } else if (properties.datalabelStyle == 'significance2') {
                      let color =
                        pointWithMetric.significance2 === '1'
                          ? 'green'
                          : pointWithMetric.significance2 === '-1'
                            ? 'red'
                            : properties.darkTheme
                              ? 'white'
                              : 'black';
                      const significance2Content = `<span style="color: ${color};"> ${pointWithMetric.cv} </span>`;
                      tooltipContent = `<span style="color:${properties.dataLabelColor
                        };">${pointWithMetric.x}% , ${pointWithMetric.y
                        }% <span  style="font-size: 80%;color: ${properties.darkTheme ? 'white' : 'black'
                        };">(${significance2Content})</span>  </span>`;
                    } else if (
                      properties.datalabelStyle === 'changeversus+significance'
                    ) {
                      tooltipContent = `<span style="color:${properties.dataLabelColor
                        };">${pointWithMetric.x}% , ${pointWithMetric.y
                        }% <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                        };">(${pointWithMetric.cv})</span></span>`;
                    } else if (properties.datalabelStyle === 'ls') {
                      if (
                        pointWithMetric.samplesize &&
                        pointWithMetric.samplesize < 12000
                      ) {
                        return 'LS';
                      }

                      return `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                    } else {
                      const metricValue: string = pointWithMetric.metric;
                      return `<span>${metricValue}<br>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                    }
                  }

                  if (pointWithMetric.significance === '1') {
                    tooltipContent +=
                      '<span style="color: green;"> &#9650;</span>';
                  } else if (pointWithMetric.significance === '-1') {
                    tooltipContent += '<span style="color: red;"> &#9660;</span>';
                  } else {
                    tooltipContent += '';
                  }

                  return tooltipContent;
                } else {
                  return `<span>${this.series.name}</span><br>X: ${pointWithMetric.x}, Y: ${pointWithMetric.y}`;
                }
              },
            },

            marker: {
              radius: 5,
              width: 10,
              height: 10,
              states: {
                hover: {
                  enabled: true,
                  lineColor: 'rgb(100,100,100)',
                },
              },
            },
            states: {
              hover: {
                enabled: false,
              },
            },
          },
        },
        xAxis: {
          max: maxX + 2,
          title: {
            text: '',
            style: {
              color: properties.darkTheme ? 'white' : 'black',
            },
          },

          labels: {
            rotation: this.chartproperties.axisLabelOrientation === 'vertical' ? -90 : (this.chartproperties.axisLabelOrientation === 'angled' ? -45 : 0),
            format:
              properties.datalabelFormat == 'percentage' ? '{value}%' : '{value}',
            style: {
              color: properties.darkTheme ? 'white' : 'black',
            },
          },
          startOnTick: true,
          endOnTick: false,
          showLastLabel: true,
          gridLineWidth: properties.gridlines === true ? 1 : 0,
          plotLines: [
            {
              color: properties.dashStyle != 'none'
                ? properties.showQuadrantcolor
                : 'transparent',
              dashStyle: properties.dashStyle,
              value: maxX / 2,
              width: 2,
              label: {
                align: 'right',
              },
            },
          ],
          plotBands: [
            {
              color:
                properties.showQuadrantcolor === 'enable' &&
                  properties.showGradient === 'enable'
                  ? {
                    linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
                    stops: [
                      [0, 'rgba(0, 0, 255, 0.2)'],
                      [1, 'rgba(0, 0, 255, 0.4)'],
                    ],
                  }
                  : properties.showQuadrantcolor === 'enable'
                    ? 'rgba(0, 0, 255, 0.2)'
                    : 'transparent',

              from: 0,
              to: xAxisPlotLine,
              label: {
                text:
                  properties.showQuadrantText === 'enable'
                    ? this.quadrantText.quadrantText1
                    : '',
                style: {
                  color: properties.darkTheme ? 'white' : 'black',
                },
                align: 'left',
                x: 10,
                y: 15,
              },
            },
            {
              color:
                properties.showQuadrantcolor === 'enable' &&
                  properties.showGradient === 'enable'
                  ? {
                    linearGradient: { x1: 1, x2: 0, y1: 0, y2: 0 },
                    stops: [
                      [0, 'rgba(0, 255, 0, 0.2)'],
                      [1, 'rgba(0, 255, 0, 0.1)'],
                    ],
                  }
                  : properties.showQuadrantcolor != 'disable'
                    ? properties.showQuadrantcolor
                    : 'transparent',

              from: -xAxisPlotLine,
              to: 0,
              label: {
                text:
                  properties.showQuadrantText === 'enable'
                    ? this.quadrantText.quadrantText2
                    : '',
                style: {
                  color: properties.darkTheme ? 'white' : 'black',
                },
                align: 'right',
                x:
                  properties.legendPosition === 'right'
                    ? properties.is3D
                      ? 600
                      : 620
                    : properties.legendPosition === 'left'
                      ? properties.is3D
                        ? 200
                        : 620
                      : properties.is3D
                        ? 400
                        : 700,
                y: properties.is3D ? 30 : 15,
              },
            },
          ],
        },
        yAxis: {
          max: maxY,
          title: {
            text: '',
            style: {
              color: properties.darkTheme ? 'white' : 'black',
            },
          },

          labels: {
            rotation: this.chartproperties.yaxisLabelOrientation === 'vertical' ? -90 : (this.chartproperties.yaxisLabelOrientation === 'angled' ? -45 : 0),
            format:
              properties.datalabelFormat == 'percentage' ? '{value}%' : '{value}',
            style: {
              color: properties.darkTheme ? 'white' : 'black',
            },
          },
          tickWidth: 1,
          lineWidth: 1,
          startOnTick: true,
          endOnTick: false,
          showLastLabel: true,
          gridLineWidth: properties.gridlines === true ? 1 : 0,
          plotLines: [
            {
              color: properties.dashStyle != 'none'
                ? properties.showQuadrantcolor
                : 'transparent',
              dashStyle: properties.dashStyle,
              value: maxY / 2,
              width: 2,
              label: {
                align: 'right',
              },
            },
          ],
          plotBands: [
            {
              color:
                properties.showQuadrantcolor === 'enable' &&
                  properties.showGradient === 'enable'
                  ? {
                    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                    stops: [
                      [0, 'rgba(255, 165, 0, 0.2)'],
                      [1, 'rgba(255, 165, 0, 0.7)'],
                    ],
                  }
                  : properties.showQuadrantcolor === 'enable'
                    ? 'rgba(255, 165, 0, 0.2)'
                    : 'transparent',

              from: 0,
              to: yAxisPlotLine,
              label: {
                text:
                  properties.showQuadrantText === 'enable'
                    ? this.quadrantText.quadrantText3
                    : '',
                style: {
                  color: properties.darkTheme ? 'white' : 'black',
                },
                align: 'right',
                x: -20,
                y: 50,
              },
            },
            {
              color:
                properties.showQuadrantcolor === 'enable' &&
                  properties.showGradient === 'enable'
                  ? {
                    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                    stops: [
                      [0, 'rgba(255, 0, 0, 0.1)'],
                      [1, 'rgba(255, 0, 0, 0.4)'],
                    ],
                  }
                  : properties.showQuadrantcolor === 'enable'
                    ? 'rgba(255, 0, 0, 0.2)'
                    : 'transparent',

              from: maxY,
              to: yAxisPlotLine,
              label: {
                text:
                  properties.showQuadrantText === 'enable'
                    ? this.quadrantText.quadrantText4
                    : '',
                style: {
                  color: properties.darkTheme ? 'white' : 'black',
                },
                align: 'left',
                x: 10,
                y: properties.is3D ? 155 : 180,
              },
            },
          ],
        },

        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: properties.toolTipStyle == 'style1' ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',

          formatter: function (this: Highcharts.TooltipFormatterContextObject) {
            const pointWithMetric = this.point as {
              x: number;
              y: number;
              metric?: string;
              cv?: string;
              significance?: string;
              significance2?: string;
              samplesize?: any;
            };

            let isDefaultTooltip = properties.toolTipStyle;
            const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
            // if (isDefaultTooltip == 'style1') {
            //   const dotColor = this.series.color;
            // const commonContent =
            //   `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color: white;">` +
            //   `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
            //   `<span><strong>Series Name:</strong></span> ${pointWithMetric.metric}<br>` +
            //   `<span><strong>Category Name:</strong></span> ${this.series.name}<br>` +
            //   `<span><strong>x value:</strong></span> ${this.point.x}<br>` +
            //   `<span><strong>y value:</strong></span> ${this.point.y}`;

            // return commonContent + '</div>';
            // }
            if (isDefaultTooltip == 'style1') {
              const dotColor = this.series.color;
              let tooltipContent = '';
              let tooltip = '';

              if (properties.datalabelFormat === 'number') {
                if (properties.datalabelStyle === 'changeversus') {
                  tooltip = `<span style="color:${properties.dataLabelColor};">${pointWithMetric.x
                    } , ${pointWithMetric.y} <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                    };">(${pointWithMetric.cv})</span></span>`;
                } else if (properties.datalabelStyle === 'significance') {
                  tooltipContent = `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                } else if (
                  properties.datalabelStyle === 'changeversus+significance'
                ) {
                  tooltipContent = `<span style="color:${properties.dataLabelColor
                    };">${pointWithMetric.x} , ${pointWithMetric.y
                    } <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                    };">(${pointWithMetric.cv})</span></span>`;
                } else if (properties.datalabelStyle == 'significance2') {
                  let color =
                    pointWithMetric.significance2 === '1'
                      ? 'green'
                      : pointWithMetric.significance2 === '-1'
                        ? 'red'
                        : properties.darkTheme
                          ? 'white'
                          : 'black';
                  const significance2Content = `<span style="color: ${color};"> ${pointWithMetric.cv} </span>`;
                  tooltipContent = `<span style="color:${properties.dataLabelColor
                    };">${pointWithMetric.x} , ${pointWithMetric.y
                    } <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                    };">(${significance2Content})</span></span>`;
                } else if (properties.datalabelStyle === 'ls') {
                  if (
                    pointWithMetric.samplesize &&
                    pointWithMetric.samplesize < 12000
                  ) {
                    tooltip = 'LS';
                  } else {
                    tooltip = `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                  }
                } else {
                  const metricValue: any = pointWithMetric.metric;
                  tooltip = `<span>${metricValue}<br>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                }
              }

              if (properties.datalabelFormat === 'percentage') {
                if (properties.datalabelStyle === 'changeversus') {
                  tooltip = `<span style="color:${properties.dataLabelColor};">${pointWithMetric.x
                    }% , ${pointWithMetric.y
                    }% <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                    };">(${pointWithMetric.cv})</span></span>`;
                } else if (properties.datalabelStyle === 'significance') {
                  tooltipContent = `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                } else if (properties.datalabelStyle == 'significance2') {
                  let color =
                    pointWithMetric.significance2 === '1'
                      ? 'green'
                      : pointWithMetric.significance2 === '-1'
                        ? 'red'
                        : properties.darkTheme
                          ? 'white'
                          : 'black';
                  const significance2Content = `<span style="color: ${color};">${pointWithMetric.cv}</span>`;
                  tooltipContent = `<span style="color:${properties.dataLabelColor
                    };">${pointWithMetric.x}% , ${pointWithMetric.y
                    }% <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                    };">(${significance2Content})</span></span>`;
                } else if (
                  properties.datalabelStyle === 'changeversus+significance'
                ) {
                  tooltipContent = `<span style="color:${properties.dataLabelColor
                    };">${pointWithMetric.x}% , ${pointWithMetric.y
                    }% <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                    };">(${pointWithMetric.cv})</span></span>`;
                } else if (properties.datalabelStyle === 'ls') {
                  if (
                    pointWithMetric.samplesize &&
                    pointWithMetric.samplesize < 12000
                  ) {
                    tooltip = 'LS';
                  } else {
                    tooltip = `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                  }
                } else {
                  const metricValue: any = pointWithMetric.metric;
                  tooltip = `<span>${metricValue}<br>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                }
              }

              if (pointWithMetric.significance === '1') {
                tooltipContent += '<span style="color: green;"> &#9650;</span>';
              } else if (pointWithMetric.significance === '-1') {
                tooltipContent += '<span style="color: red;"> &#9660;</span>';
              }

              let tooltip1 =
                properties.datalabelStyle === 'ls' ||
                  properties.datalabelStyle === 'changeversus' ||
                  properties.datalabelStyle === 'default'
                  ? tooltip
                  : tooltipContent;
              const commonContent =
                `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color: white;">` +
                `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
                `<span><strong>Series Name:</strong></span> ${pointWithMetric.metric}<br>` +
                `<span><strong>Category Name:</strong></span> ${this.series.name}<br>` +
                ` ${tooltip1}<br>`;

              return commonContent + '</div>';
            } else {
              // const dotColor = this.series.color; // Get the series color
              // const content =
              //   `<div style="background-color: #f5f5f5; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
              //   `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"></div>` +
              //   ` ${this.series.name}` +
              //   `<div style="display: block; margin-top: 5px;"><strong>x value:</strong> ${this.point.x}</div>` +
              //   `<div style="display: block; margin-top: 5px;"><strong>y value:</strong> ${this.point.y}</div>`;

              // return content + '</div>';

              const dotColor = this.series.color;
              let tooltipContent = '';
              let tooltip = '';

              if (properties.datalabelFormat === 'number') {
                if (properties.datalabelStyle === 'changeversus') {
                  tooltip = `<span style="color:${properties.dataLabelColor};">${pointWithMetric.x
                    } , ${pointWithMetric.y} <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                    };">(${pointWithMetric.cv})</span></span>`;
                } else if (properties.datalabelStyle === 'significance') {
                  tooltipContent = `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                } else if (
                  properties.datalabelStyle === 'changeversus+significance'
                ) {
                  tooltipContent = `<span style="color:${properties.dataLabelColor
                    };">${pointWithMetric.x} , ${pointWithMetric.y
                    } <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                    };">(${pointWithMetric.cv})</span></span>`;
                } else if (properties.datalabelStyle == 'significance2') {
                  let color =
                    pointWithMetric.significance2 === '1'
                      ? 'green'
                      : pointWithMetric.significance2 === '-1'
                        ? 'red'
                        : properties.darkTheme
                          ? 'white'
                          : 'black';
                  const significance2Content = `<span style="color: ${color};"> ${pointWithMetric.cv} </span>`;
                  tooltipContent = `<span style="color:${properties.dataLabelColor
                    };">${pointWithMetric.x} , ${pointWithMetric.y
                    } <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                    };">(${significance2Content})</span></span>`;
                } else if (properties.datalabelStyle === 'ls') {
                  if (
                    pointWithMetric.samplesize &&
                    pointWithMetric.samplesize < 12000
                  ) {
                    tooltip = 'LS';
                  } else {
                    tooltip = `<span>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                  }
                } else {
                  const metricValue: any = pointWithMetric.metric;
                  tooltip = `<span>${metricValue}<br>${pointWithMetric.x} , ${pointWithMetric.y}</span>`;
                }
              }

              if (properties.datalabelFormat === 'percentage') {
                if (properties.datalabelStyle === 'changeversus') {
                  tooltip = `<span style="color:${properties.dataLabelColor};">${pointWithMetric.x
                    }% , ${pointWithMetric.y
                    }% <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                    };">(${pointWithMetric.cv})</span></span>`;
                } else if (properties.datalabelStyle === 'significance') {
                  tooltipContent = `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                } else if (properties.datalabelStyle == 'significance2') {
                  let color =
                    pointWithMetric.significance2 === '1'
                      ? 'green'
                      : pointWithMetric.significance2 === '-1'
                        ? 'red'
                        : properties.darkTheme
                          ? 'white'
                          : 'black';
                  const significance2Content = `<span style="color: ${color};">${pointWithMetric.cv}</span>`;
                  tooltipContent = `<span style="color:${properties.dataLabelColor
                    };">${pointWithMetric.x}% , ${pointWithMetric.y
                    }% <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                    };">(${significance2Content})</span></span>`;
                } else if (
                  properties.datalabelStyle === 'changeversus+significance'
                ) {
                  tooltipContent = `<span style="color:${properties.dataLabelColor
                    };">${pointWithMetric.x}% , ${pointWithMetric.y
                    }% <span style="font-size: 80%; color: ${properties.darkTheme ? 'white' : 'black'
                    };">(${pointWithMetric.cv})</span></span>`;
                } else if (properties.datalabelStyle === 'ls') {
                  if (
                    pointWithMetric.samplesize &&
                    pointWithMetric.samplesize < 12000
                  ) {
                    tooltip = 'LS';
                  } else {
                    tooltip = `<span>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                  }
                } else {
                  const metricValue: any = pointWithMetric.metric;
                  tooltip = `<span>${metricValue}<br>${pointWithMetric.x}% , ${pointWithMetric.y}%</span>`;
                }
              }

              if (pointWithMetric.significance === '1') {
                tooltipContent += '<span style="color: green;"> &#9650;</span>';
              } else if (pointWithMetric.significance === '-1') {
                tooltipContent += '<span style="color: red;"> &#9660;</span>';
              }

              let tooltip1 =
                properties.datalabelStyle === 'ls' ||
                  properties.datalabelStyle === 'changeversus' ||
                  properties.datalabelStyle === 'default'
                  ? tooltip
                  : tooltipContent;
              // const content =
              //   `<div style="background-color: #f5f5f5; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
              //   `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"></div>` +
              //   ` ${this.series.name}<br>` +
              //   ` ${tooltip1}<br>`;

              // return content + '</div>';
              //const dotColor = pointWithMetric.color; // Get the series color

              // const content =
              //   `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor};font-size:0.7rem;max-width:10em;width:10em">` +
              //   `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0;font-size:0.7rem">${this.series.name}</div></div>` +
              //   `<div style="display: block; margin-top: 5px;;font-size:0.7rem"> ${pointWithMetric.tooltip}</div>`;

              // return content + '</div>';
              const commonContent =
              `<div style="border-left: 2px solid ` + dotColor + `;font-size:0.8rem; border-bottom: 2px solid ` + dotColor + `; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
              `<span> ${this.series.name} : ${pointWithMetric.x}%</span><br>` +
              `<span>${pointWithMetric.metric} : ${pointWithMetric.y}%</span>`;
              return commonContent + '</div>';
            }
          },
        },
        series: this.seriesdata,
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
      } as any);
    }
  }

  customization(): Observable<any[]> {
    return this._customSnapshotService.getChartCustomization("Scatter Chart", this._customSnapshotService.selectedSnapshotType?.name);

    //return this.ss.QuadrantScatterChartCustomizationList();
  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.ss.applycustomization(event, item, this.chartproperties)
    this.generatechart(
      'chart-container' + this.id,
      this.data,
      this.chartproperties,
      this.seriesdata
    );
  }

  userselectedproperties() {
    let quadrantName = [
      this.quadrantText.quadrantText1,
      this.quadrantText.quadrantText2,
      this.quadrantText.quadrantText3,
      this.quadrantText.quadrantText4,
    ];
    this.jsondata['properties'][0] = this.chartproperties;
    this.jsondata['quadrantText'] = quadrantName;
    return JSON.stringify(this.jsondata).toString();
  }

  updateSig() {
    this.subscriptions.add(
      this.http.get<any>('assets/Data/scatterData.json').subscribe((data: any) => {
        this.jsondata = data;
        //this.data = data[0];
        this.data = data[0]["data"];
        this.chartproperties = data[0]["properties"][0];
        // ;
        this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
        this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "default" : "sigChange";
        this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_99
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_99
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_99
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_99
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
        this.preparemainChartData(this.customData);//extra added(req)
        this.getData(this.jsondata, this.chartproperties.datalabelStyle == "ls");
        this.generatechart('chart-container' + this.id, this.chartMainData,
          this.chartproperties,
          this.seriesdata);
      }));

  }

  getData(chartData: any, lowSample1: any) {
    if (this.isOutput) {

    }
    else {

    }
  }

  preparemainChartData(data: any) {
    let i = 0;
    data.forEach((item: any) => {
      item.metric_value.forEach((d: any) => {
        const hasMean = d.option?.toLowerCase().includes("mean");
        if (item.metric_option.includes("XAxis Metric") && hasMean) {
          this.percentageForX = true;
        } else if (hasMean) {
          this.percentageForY = true;
        }
      });
    });

    this.chartMainData = [];

    data.filter((a: any) => a.metric_option.toLowerCase().includes("xaxis"))[0].metric_value.forEach((xaxis: any) => {
      this.xAxisTitle = xaxis.option
      xaxis.data.forEach((dataArr: any) => {

        let yaxisData = data.filter((a: any) => a.metric_option.toLowerCase().includes("yaxis"))[0].metric_value[0].data.filter((a: any) => a.colChild == dataArr.colChild)[0];
        this.yAxisTitle = yaxisData?.rowChild;
        let d1 = {
          "brand":  dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild,
          "data": [{
            //"x": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? Number((dataArr.data * 100).toFixed(this.chartproperties.decimalRoundOff)) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : Number((dataArr.data * 100).toFixed(this.chartproperties.decimalRoundOff))),
            "x": dataArr.data!==null?(dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? Number((dataArr.data * 100).toFixed(this.chartproperties.decimalRoundOff)) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : Number((dataArr.data).toFixed(this.chartproperties.decimalRoundOff)))):0,
            "y":yaxisData.data!==null?(yaxisData.CalculationType?.toLowerCase() == "share" || yaxisData.CalculationType?.toLowerCase() == "respgrp" ? Number((yaxisData.data * 100).toFixed(this.chartproperties.decimalRoundOff)) : (yaxisData.CalculationType?.toLowerCase() == "index" && yaxisData.data == "NA" ? "NA" : Number((yaxisData.data).toFixed(this.chartproperties.decimalRoundOff)))):0,
            //"y": yaxisData.CalculationType?.toLowerCase() == "share" || yaxisData.CalculationType?.toLowerCase() == "respgrp" ? Number((yaxisData.data * 100).toFixed(this.chartproperties.decimalRoundOff)) : (yaxisData.CalculationType?.toLowerCase() == "index" && yaxisData.data == "NA" ? "NA" : Number((yaxisData.data * 100).toFixed(this.chartproperties.decimalRoundOff))),
            "metric": "",
            "ChangeVsx": dataArr.changeVsPY,
            "ChangeVsy": yaxisData.changeVsPY,
            "Significance": "-1",
            "Significance2": "1",
            "Sample sizex": dataArr.baseValueforLSorIs,
            "Sample sizey": yaxisData.baseValueforLSorIs,
            "ValueForIndexx": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValuex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ValueForIndexy": (yaxisData.CalculationTypeIndex?.toLowerCase() == "index" && yaxisData.data2 == "NA" ? "NA" : yaxisData.data2),
            "ActualIndexValuey": (yaxisData.CalculationTypeIndex?.toLowerCase() == "index" && yaxisData.data2 == null) ? null : (yaxisData.CalculationTypeIndex?.toLowerCase() == "index" && yaxisData.data2 == "NA" ? "NA" : yaxisData.data2),
            "isPercentageX": (dataArr.CalculationType?.toLowerCase() == "mean" || dataArr.CalculationType?.toLowerCase() == "respgrp") && !this.percentageForX ? true : false,
            "isPercentageY": (dataArr.CalculationType?.toLowerCase() == "mean" || dataArr.CalculationType?.toLowerCase() == "respgrp") && !this.percentageForY ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Valuex": dataArr.Significance_Value,
            "Significance_Valuey": yaxisData.Significance_Value,
          }],
          "image": dataArr.colChild
        }

        this.chartMainData.push(d1);
      });
    });

  }
}
